/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { useContext } from "react";
import { EditorContext } from "../../Context/EditorContext";
import Logo from "../../img/logo.png";

const LeftMenu = () => {
  const { title, name } = useContext(EditorContext);

  return (
    <div css={styles} className="leftMenu">
      <img src={Logo} alt="logo" />
      <div className="info">
        <h2>{title}</h2>
        <p>{name}</p>
      </div>
    </div>
  );
};

const styles = css`
  min-height: 45px;
  display: flex;
  align-items: center;
  img {
    width: 60px;
    height: auto;
    display: block;
  }
  .info {
    color: #fff;
    padding-left: 14px;
  }
`;

export default LeftMenu;
